import React, {useEffect, useRef, useState} from 'react';
import {Button, Input, Table, Form} from 'antd';
import {useBreadcrumbComponent} from "@common/useBreadcrumbComponent";
import axios from "axios";
import {ArrowForwardRounded, SearchOffRounded, SearchRounded} from "@mui/icons-material";
import {useLocation} from "wouter";
import TableFilterControlsForm from "@common/TableFilterControlsForm";
import TableFilterControlsSection from "@common/TableFilterControlsSection";
import TableFilterControls from "@common/TableFilterControls";
import PageHeader from "@common/PageHeader";

const { Search } = Input;

const StudentReportSearch = () => {
    const BreadcrumbBar = useBreadcrumbComponent({ dropLast: true });
    const allStudentsRef = useRef([]);
    const [searchValue, setSearchValue] = useState('');
    const [results, setResults] = useState([]);
    const [, navigate] = useLocation();

    const filterValidStudents = (data) => {
        return Object.entries(data)
            .filter(([, value]) => value.subscriberType === 'STUDENT')
            .map(([key, value]) => ({
                key,
                ...value
            }));
    };

    useEffect(() => {
        axios.get('/web/ui/sc/users')
            .then(response => {
                allStudentsRef.current = filterValidStudents(response.data);
            })
            .catch(error => {
                console.error('Failed to fetch students:', error);
            });
    }, []);

    const handleSearch = (value) => {
        const query = value.toLowerCase();
        setSearchValue(value);

        if (!query.trim()) {
            setResults([]);
            return;
        }

        const filteredResults = allStudentsRef.current.filter(student =>
            student.fullName.toLowerCase().includes(query) ||
            student.email.toLowerCase().includes(query)
        );

        setResults(filteredResults);
    };

    const handleStudentNameClick = (studentRecord) => {
        navigate(`/web/ui/view/reports/studentReport/${studentRecord.userId}`);
    };

    const columns = [
        {
            title: 'Student Name',
            dataIndex: 'fullName',
            key: 'name',
            render: (text, record) => (<Button type={'link'} onClick={() => handleStudentNameClick(record)}><strong>{text}</strong> <ArrowForwardRounded /></Button>)
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        }
    ];

    const generateEmptyContainerContent = () => {
        if(searchValue.trim()){
            return(
                <div className={'ch-student-report-search-empty-table'}>
                    <SearchOffRounded fontSize={'large'} />
                    <strong>No students found</strong>
                </div>
            )
        } else {
            return (
                <div className={'ch-student-report-search-empty-table'}>
                    <SearchRounded fontSize={'large'} />
                    <em>Enter a student name to search</em>
                </div>
            )
        }
    }

    return (
        <div>
        <BreadcrumbBar />
            <PageHeader title={'Student Report Search'} />
            <TableFilterControlsForm>
                <TableFilterControlsSection showDivider={false}>
                    <Form.Item label={'Student search'}>
                        <Search
                            placeholder={'Student name'}
                            allowClear
                            enterButton="Search"
                            size="middle"
                            onSearch={handleSearch}
                        />
                    </Form.Item>
                </TableFilterControlsSection>
            </TableFilterControlsForm>
            <Table
                columns={columns}
                dataSource={results}
                locale={{
                    emptyText: generateEmptyContainerContent()
                }}
                style={{ marginTop: 16 }}
            />
        </div>
    );
};

export default StudentReportSearch;